// State argument is not application state, only the state this reducer is responsible for
function loading(state = false, action) {
  console.log("loading reducer", state, action);
  
  switch (action.type) {
    case "IS_LOADING":
      return true;
    case "IS_LOADING_TEXT":
      return action.payload;
    case "NOT_LOADING":
      return false;
    default:
      return state;
  }
}

export default loading;
